import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/strategy_undefined.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "label" }

import enUK from "@/locales/home/en-UK.json";

import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import useMutationHandlers from "@/composables/useMutationHandlers";
import { GET_BASIC_PROJECT } from "@/graphql/project/queries";

type MessageSchema = typeof enUK;

interface Props {
  id?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectStrategy',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const { createErrorHandler } = useMutationHandlers();

const { result: projectResult, onError: onProjectError } = useQuery(
  GET_BASIC_PROJECT,
  () => ({
    id: props.id,
  }),
);

onProjectError(createErrorHandler("getProject"));

const project = computed(() => projectResult.value?.project);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (project.value?.architectureImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "main-image",
            src: project.value.architectureImage.url,
            alt: _unref(t)('architectureImage.alt')
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (!project.value?.architectureImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _unref(t)('architectureImage.default.alt')
          }, null, 8, _hoisted_5),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(t)("architectureImage.default.label")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})